<template>
	<div class="login">
		<div class="ttp">
			
			<!-- 注册中心 -->
			<div class="login-box" >
				<div class="login-box-header">
					<h2 style="color: #FFFFFF;">{{$t('registor.center')}}</h2>
					
					<div class="langBox">
						<el-select  style="width: 120px;" size="mini" @change="switchLangq(value)" v-model="value" placeholder="Language">
						    <el-option
						      v-for="item in options"
						      :key="item.value"
						      :label="item.label"
						      :value="item.value">
						    </el-option>
						 </el-select>
					</div>
				
				</div>
				<div class="login-main">
					<span style="border-bottom: 1px #eee solid;">
						<label style="display:inline-block;width:100px;text-align:right">{{$t('other.a520')}}<i style="color: red;">*</i> ：</label>
						<el-input  class="input-text" v-model="registor_inputCountID" :placeholder="$t('registor.mail')"></el-input>
					</span>
					<span style="border-bottom: 1px #eee solid;">
						<label style="display:inline-block;width:100px;text-align:right">{{$t('other.a464')}}<i style="color: red;">*</i> ：</label>
						<el-input class="input-text"  type="password" v-model="registor_password" :placeholder="$t('registor.passsword')"></el-input>
					</span>
					<span style="border-bottom: 1px #eee solid;">
						<label style="display:inline-block;width:100px;text-align:right">{{$t('other.a431')}}<i style="color: red;">*</i> ：</label>
						<el-input class="input-text" type="password"   v-model="registo_comfirPws" :placeholder="$t('registor.confirm_pws')"></el-input>
					</span>
					<span style="border-bottom: 1px #eee solid;position:relative">
						<label style="display:inline-block;width:100px;text-align:right">{{$t('other.a401')}}<i style="color: red;">*</i> ：</label>
						<el-input class="input-text"    v-model="emailCode" :placeholder="$t('registor.verification')"></el-input>
						<div style="position:absolute;right:5px;bottom:20px;font-size: 14px;cursor: pointer;color:red" @click="getemailCode">{{$t('registor.getCode')}}</div>	
					</span>
					<span style="border-bottom: 1px #eee solid;">
						<label style="display:inline-block;width:100px;text-align:right">{{$t('other.a465')}}：</label>
						<el-input class="input-text" v-model="registor_inputusername" :placeholder="$t('registor.nickname')"></el-input>
					</span>
					<span style="border-bottom: 1px #eee solid;">
						<label style="display:inline-block;width:100px;text-align:right">{{$t('other.a434')}}：</label>
						<el-input class="input-text" v-model="registor_invitationCode" :placeholder="$t('registor.invitationCode')"></el-input>
					</span>
					
					<span style="border-bottom: 1px #eee solid;">
						<label style="display:inline-block;width:100px;text-align:right">{{$t('other.a521')}}<i style="color: red;">*</i> ：</label>
						<el-input class="input-text"    v-model="phone" :placeholder="$t('registor.phone')"></el-input>	
					</span>
					
					<div style="display: flex;justify-content: space-between;align-items: center;">
						<div class="tologin" @click="gotoLogin">{{$t('registor.log')}}</div>
						
					</div>
					<el-button class="input-text" type="primary" @click="registoer">{{$t('registor.register')}}</el-button>
					
				</div>
			</div>
			
			
		</div>
		
		
	</div>
</template>

<script >
	import md5 from 'js-md5';
	import {mapState, mapActions , mapMutations} from 'vuex'
	export default{
		data() {
			return{
				emailCode:null,
				registor_inputCountID:'',
				countryvalue:null,
				country: [{
					  value: 'CN',
					  label: 'China'
					},{
					  value: 'TH',
					  label: 'Thailand'
				 },{
					  value: 'PH',
					  label: 'Philippines'
				 },{
					  value: 'ID',
					  label: 'Indonesia'
				 },{
					  value: 'TW',
					  label: 'Taiwan'
				 },{
					  value: 'SG',
					  label: 'Singapore'
				 },{
					  value: 'BZ',
					  label: 'Brazil'
				 },{
					  value: 'MY',
					  label: 'Malaysia'
				 },{
					  value: 'VN',
					  label: 'Vietnam'
				 }],
				registor_inputusername:'',
				registor_password:'',
				registo_comfirPws:'',
				registor_invitationCode:'',
				inputCount: '' ,
				inputPassword:'',
				start_time:'',
				end_time:'',
				options: [{
				          value: 'zh',
				          label: '中文'
				        }, {
				          value: 'en',
				          label: 'English'
				 }],
				 value: '',
				 checked:false,
				 islogin:true,
				 phone:''
			}
		},
		computed:{
			...mapState({
				userInfo:state =>state.login.userInfo,
				loginStatus:state =>state.login.loginStatus,
				hasLogin:state =>state.login.hasLogin,
				registorSuccess:state =>state.login.registorSuccess,
			})
		},
		watch:{
			hasLogin(){
				setInterval(() =>{
					this.gotoindex()
				},500)
				
			},
	
			
		},
		
		created(){
			this.init()
		},
		mounted(){
		    //绑定事件
		     window.addEventListener('keydown',this.keyDown);
		  },
		destroyed(){
			  window.removeEventListener('keydown',this.keyDown,false);
		},
		  
	
		methods:{
			...mapActions('login',[
				'getEmailCode',
				'getRegister'
			]),
			
			...mapMutations('login', [
				'SWITCH_LANG',
			]),
			
			
			
			getemailCode(){
				let passwordreg = /^.{6,20}$/
				if(!passwordreg.test(this.registor_password)) {
					this.$message.error(this.$t('other.a522'))
						return
				}
				if(!this.registor_inputCountID) {
					this.$message.error(this.$t('other.a523'))
					retur
				}else{
					
					
					const params={
						email:this.registor_inputCountID
					}
					this.getEmailCode(params)
				}
				
			},
			registoer(){
				let passwordreg =/^.{6,20}$/
				let mailCountreg=/^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/
				if(!mailCountreg.test(this.registor_inputCountID)) {
					this.$message.error(this.$t('other.a524'))
						return
				}
				if(!passwordreg.test(this.registor_password)) {
					this.$message.error(this.$t('other.a522'))
						return
				}
				if(!this.emailCode && !this.registor_inputusername && !this.registo_comfirPws) {
					this.$message.error(this.$t('other.a525'))
					return
				}
				if(this.registor_password !== this.registo_comfirPws) {
					this.$message.error(this.$t('other.a526'))
					return
				}
				if(!this.phone) {
					this.$message.error(this.$t('other.a527'))
					return
				}
				if(!this.emailCode) {
					this.$message.error(this.$t('other.a528'))
					return
				}
				if(!this.registor_inputCountID || !this.registor_inputusername) {
					this.$message.error(this.$t('other.a529'))
					return
				}
				const params={
					emailCode:this.emailCode,
					password:md5(this.registor_password + 'seller'),
					user:{
						userEmail:this.registor_inputCountID,
						userName:this.registor_inputusername,
						userPos:'SELLER',
						userPhone:this.phone,
						country:this.countryvalue,
						invitationCode:this.registor_invitationCode
					}
				}
				console.log(params)
				this.getRegister(params).then(res => {
					
					if(res == 'hasSuccess'){
						setInterval(() =>{
						this.$router.push('/loginPage')
						},1000)
					}
				})
			},
			init(){
				let url=location.href
				
				if(url.indexOf('?') > -1) {
					
					let code=url.split('?')
					let ttp=code[1].split('=')[1]
					console.log('code',ttp)
					this.registor_invitationCode=ttp
				}

				let account=JSON.parse(localStorage.getItem('userCount'))
				if(account){
					this.checked=true
					this.inputCount=account.account
					this.inputPassword=account.passsword
				}else{
					this.checked=false
				}
			},
			keyDown(e){
				if(e.keyCode === 13) {
					this.getLogin()
					
				}
			},
			switchLangq(value){
				this.SWITCH_LANG(value)
				this.$i18n.locale =  value 
				
			},
			gotoLogin(){
				this.$router.push('/loginPage')
			},
			
		
		}
	}
</script>

<style scoped>

	
	.login{
			
			width: 100%;
			height: 100vh;
			background-color: #fff;
			position: absolute;
			/* background-image: url(../assets/img/loginbackground.png); */
			background-repeat:no-repeat; 
			background-size: cover;
			-webkit-background-size: cover;
			-o-background-size: cover;
			background-position: center 0;
			z-index: 2000;
			
	
		}
		
		.tologin{
			color: red;
			cursor: pointer;
			margin-left: 15px;
		}
		
		.tologin:hover{
			
			color: #66b1ff;
		}
		
		.langBox{
			position: absolute;
			top: 10px;
			right: -130px;
		}
		
		.login-box{
			
			   
			  
			  width: 438px;
			  border-radius: 10px;
			  background: #fff;
			  box-shadow: 0 0 25px #cac6c6;
	
		}
		.login-desc{
	
			width: 600px;
			height: 480px;
			background-color: #333536;
			opacity: 0.8;
			color: #fff;
			border-radius: 10px;
			box-sizing: border-box;
			padding: 20px 20px;
			z-index: -1;
		}
		.login-left,.login-right{
			width: 50%;
		}
		.pic-box{
			display: inline-block;
			width:155px;
			height: 155px;
		}
		
		.ppt{
			display: flex;
			justify-content:space-between;
			margin: 40px 0;
			
		}
		
		.login-title{
		
			font-size: 20px;
			font-weight: bold;
		}
		
		.input-text{
		
			width: 300px;
			margin: 10px 0;
		}
		
		.login-left,.login-right{
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
		}
	
		.registor{
			width: 80%;
			text-align: right;
			cursor: pointer;
		}
		
		

		
		.login-box-header{
			height: 180px;
			background-image: url(../assets/img/login_01.png);
			background-repeat:no-repeat;
			background-size:100%;
			border-radius: 10px;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			position: relative;
		}
		.login-main{
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
		}
		
		.input-btn{
			width: 200px;
			border-radius: 30px;
			margin: 50px;
		}
		
		.login-item{
			display: inline-block;
			margin: 10px 0;
			font-size: 18px;
			font-weight: bold;
			color: #FFFFFF;
		}
		
		.login-desc-item{
			font-weight: bold;
			line-height: 50px;
			margin-bottom: 20px;
		}
		
		.login .ttp{
			width: 100%;
			display: flex;
			justify-content: space-around;
			box-sizing: border-box;
			margin-top: 10px;
			position: relative;
			
			
		}
		
		.ppt-item{
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			width: 50px;
			height: 50px;
		}
	
		 .el-input__inner{
			width: 250px;
			border: none!important;
		}
		 .el-input--mini{
			width: 170px!important;
		}
</style>
